export default __webpack_public_path__ + "static/media/SlideFive.ab04b787.png";